export default __webpack_public_path__ + "static/media/ic-edit-price.019fc1f7.svg";